var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoWhiteCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 6.75C12.0858 6.75 11.75 6.41421 11.75 6C11.75 5.58579 12.0858 5.25 12.5 5.25H12.5001C12.9143 5.25 13.2501 5.58579 13.2501 6C13.2501 6.41421 12.9143 6.75 12.5001 6.75H12.5ZM13.25 10.5002C13.25 10.086 12.9142 9.75021 12.5 9.75021C12.0858 9.75021 11.75 10.086 11.75 10.5002V18.0001C11.75 18.4143 12.0858 18.7501 12.5 18.7501C12.9142 18.7501 13.25 18.4143 13.25 18.0001V10.5002Z",
    fill: "#DE2100"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoWhiteCircle);
export default __webpack_public_path__ + "static/media/info-white-circle.d049c4e481c73df59933ac67747be28f.svg";
export { ForwardRef as ReactComponent };